import { Component, Inject, Signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventCounter } from 'src/app/models/eventCounters.model';

@Component({
  selector: 'app-event-balance',
  templateUrl: './event-balance.component.html',
  styleUrl: './event-balance.component.scss',
  standalone: false,
})
export class EventBalanceComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public eventCounter: Signal<EventCounter>,
  ) {}
}
